export default __webpack_public_path__ + "be18099c7e11ac8e10736d069d51dac4.svg";